import React from "react";

function Warranty() {
  return (
    <div className="p-6 max-w-4xl mx-auto text-gray-800">
      <h1 className="text-2xl font-bold mb-4">Warranty Policy</h1>
      <p className="mb-4">
        Durapot Repair offers you a 6-month + 1-month breakage warranty on
        every pot repaired/replaced by us from the date of invoice.
        We also provide a 3-month warranty on all other spare parts replaced.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">What the Warranty Covers:</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Screen malfunctions or touch issues</li>
        <li>Display issues without manual damage</li>
        <li>One-time screen replacement within 1 month</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Warranty Claim Process:</h2>
      <p className="mb-4">To claim your warranty, follow these steps:</p>
      <ol className="list-decimal ml-6 mb-4">
        <li>Share a video of the issue at <a href="mailto:admin@jodisure.com" className="text-blue-500">admin@jodisure.com</a></li>
        <li>Send your order number, phone number, or IMEI number</li>
        <li>We will respond within 48-72 hours</li>
      </ol>

      <h2 className="text-xl font-semibold mt-6 mb-2">Warranty Exclusions:</h2>
      <p className="mb-4">
        The warranty does not cover the following situations:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Accidental damage (e.g., drops, hard presses)</li>
        <li>Water damage</li>
        <li>Tampering with internal hardware</li>
        <li>Software issues unrelated to the repair</li>
        <li>Loss of data due to repair</li>
      </ul>

    </div>
  );
}

export default Warranty;
